export const displayUnitPrice = (item) => {
  if (!item.unitPrice) {
    return 'N/A';
  }

  return `$${item.unitPrice}`;
};
